module.exports = __webpack_public_path__ + "img/t1.9286b924.jpg";